import styled from '@emotion/styled';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, ClickAwayListener, Grid, IconButton, Paper, Popper } from '@mui/material';
import React, { useRef, useState } from 'react';

import { WsMenuList } from '../../components/WsMenuList';
import { commonPopperModifiers } from '../../types/CommonPopperModifiers';

export interface IWsMoreOptionButton {
  onItemClick: (option: string) => void;
  items: string[];
}

const StyledPaper = styled(Paper)({
  borderRadius: '12px',
  border: '1px solid #D3D8DB',
  width: 40,
  height: 40,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const WsMoreOptionButton = ({ onItemClick, items = [] }: IWsMoreOptionButton) => {
  const [listOpenStatus, setListOpenStatus] = useState<boolean>(false);
  const anchorRef = useRef<HTMLDivElement | null>(null);
  const handleMenuList = () => setListOpenStatus((prev) => !prev);
  const handleClose = () => setListOpenStatus(false);

  return (
    <>
      <Grid container ref={anchorRef}>
        <StyledPaper elevation={0}>
          <IconButton size="small" sx={{ padding: 0 }} onClick={handleMenuList}>
            <MoreVertIcon sx={{ color: '#2F4F57' }} />
          </IconButton>
        </StyledPaper>
      </Grid>

      <Popper
        open={listOpenStatus}
        anchorEl={anchorRef.current}
        placement="bottom-start"
        modifiers={commonPopperModifiers}
        style={{ zIndex: 1300 }}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <Box>
            <WsMenuList menuOptions={items} onItemClick={(index) => onItemClick(items[index])} />
          </Box>
        </ClickAwayListener>
      </Popper>
    </>
  );
};

export default WsMoreOptionButton;
